export interface QuotationModalData {
    id : string;
    inspectionType: string;
    quotationNumber : string;
    vesselName : string;
}

export const initialDeleteQuotationModalData : QuotationModalData = {
    vesselName: "",
    inspectionType: "",
    quotationNumber: "",
    id: ""
}